import slick from 'slick-carousel';

jQuery( '.js-content-slider' ).slick( {
	rows: 0,
	arrows: false,
	dots: true,
	appendDots: '.c-content-slider__subheading',
	adaptiveHeight: true,
	autoplay: true,
	autoplaySpeed: 6000,
	fade: true,
	pauseOnHover: true,
	pauseOnFocus: true,
	responsive: [
		{
			breakpoint: 992,
			settings: {
				appendDots: '.c-content-slider__item',
			}
		}
	]
} ).on( 'afterChange', function( event, slick, currentSlide ) {
	jQuery.each( slick.$dots, ( i, el ) => {
		jQuery( el ).find( 'li' ).eq( currentSlide ).addClass( 'slick-active' ).find( 'button' );
	})
});